module.exports = __webpack_public_path__ + "img/canales-mercar.0d0e8bc1.svg";